import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BoutonIcon from "./boutonIcon";
import ImageIcon from "../icons/image";
import Overlay from "../molecules/overlay";
import ImageJoueur from "./imageJoueur";
import VideoIcon from "../icons/video";

const Joueur = ({joueur}) => {
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);
    const [overlayContent, setOverlayContent] = useState('image');

    const openOverlay = (contentType) => {
        setOverlayContent(contentType);
        setIsOverlayOpen(true);
    }

    const handleLienTemporaire = () => {
        if (joueur.lienTemporaire) {
            openOverlay('imageTemporaire')
        }
    }

    return (
        <>
            <div
                className={`relative flex items-center bg-[#1A1A1A] bg-opacity-70 px-3 md:px-6 py-3 rounded-lg hover:bg-[#222222] hover:bg-opacity-90 hover:shadow-lg transition-all duration-300 cursor-pointer min-h-0 flex-shrink ${joueur.lienTemporaire ? 'border-2 border-red-500 animate-pulse-border' : ''}`}
                onClick={handleLienTemporaire}
            >
                {joueur.lienTemporaire && (
                    <div className="absolute top-0 left-0 bg-red-500 text-white text-[8px] font-bold px-1 py-0.5 rounded-sm shadow-lg z-10 leading-none">
                        NEW
                    </div>
                )}
                {joueur.role === 'COACH' ? (
                    <img src={process.env.PUBLIC_URL + `/images/roles/${joueur.role}.png`} alt={`Role ${joueur.role}`} className="w-7 h-7" />
                ) : (
                    <img src={process.env.PUBLIC_URL + `/images/roles/${joueur.role}.png`} alt={`Role ${joueur.role}`} className="w-5 h-5" />
                )}
                <h1 className="text-white font-semibold text-base md:text-lg ml-3 md:ml-6 mr-2 md:mr-3 font-poppins flex-shrink-0">{joueur.pseudo}</h1>
                <h2 className="text-gray-400 font-semibold text-xs font-poppins border-l border-gray-600 px-2 md:px-4 truncate min-w-0">
                    {joueur.nom} {joueur.prenom}
                    {joueur.inactif && <span className="text-red-500"> - INACTIF</span>}
                    {joueur.fincontrat && <span className="text-gray-500 ml-2">· {joueur.fincontrat}</span>}
                </h2>
                <div className="flex gap-3 ml-auto">
                    <BoutonIcon
                        icon={<ImageIcon/>}
                        onClick={(e) => {
                            e.stopPropagation();
                            openOverlay('image');
                        }}
                    />
                    {joueur.video && (
                        <BoutonIcon
                            icon={<VideoIcon/>}
                            onClick={(e) => {
                                e.stopPropagation();
                                openOverlay('video');
                            }}
                        />
                    )}
                </div>
            </div>
            {isOverlayOpen && (
                <Overlay onClose={() => setIsOverlayOpen(false)}>
                    {overlayContent === 'image' ? (
                        <ImageJoueur nom={joueur.pseudo} />
                    ) : overlayContent === 'video' ? (
                        <iframe
                            src={`${joueur.video}?autoplay=1`}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            className="w-[90vw] h-[90vh] max-w-[1600px] max-h-[900px] rounded-md"
                        />
                    ) : (
                        <ImageJoueur nom={joueur.lienTemporaire} dossierImage="temp"/>
                    )}
                </Overlay>
            )}
            <style jsx>{`
                @keyframes pulse-border {
                    0%, 100% {
                        box-shadow: 0 0 5px rgba(239, 68, 68, 0.5);
                    }
                    50% {
                        box-shadow: 0 0 20px rgba(239, 68, 68, 1);
                    }
                }
                .animate-pulse-border {
                    animation: pulse-border 2s ease-in-out infinite;
                }
            `}</style>
        </>
    )
}

Joueur.propTypes = {
    joueur: PropTypes.shape({
        pseudo: PropTypes.string.isRequired,
        nom: PropTypes.string,
        prenom: PropTypes.string,
        role: PropTypes.string,
        video: PropTypes.string,
        lienTemporaire: PropTypes.string,
        inactif: PropTypes.bool,
        fincontrat: PropTypes.string,
    }).isRequired,
}

export default Joueur;